import { useContext } from 'react';
import { AccessContext } from 'context/index';

const useAccess = () => {
  return useContext(AccessContext);
};

export default useAccess;
